import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-x-replication",
  "use": "app-icon-x-replication-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-x-replication\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#6C7280\" d=\"M2.5 6.933H17v14.5H2.5z\" /><path fill=\"#FFF\" d=\"M4 8.433h11.5v11.5H4z\" /><path stroke=\"#6C7280\" stroke-width=\"1.5\" d=\"M7.833 3.5H20.5v12.667\" /><path d=\"M0 0h24v24H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol